import makeStyles from '@material-ui/core/styles/makeStyles';

export const style = makeStyles({
  greyText: {
    color: '#8590a6',
  },
});
